import { render } from "./KeepWatchingSection.vue?vue&type=template&id=29c81ce6&scoped=true"
import script from "./KeepWatchingSection.vue?vue&type=script&lang=js"
export * from "./KeepWatchingSection.vue?vue&type=script&lang=js"

import "./KeepWatchingSection.vue?vue&type=style&index=0&id=29c81ce6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c81ce6"]])

export default __exports__